<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="field col-12 md:col-2">
                        <button pButton pRipple (click)="abrirDialogCaixa()" pTooltip="Abrir novo Caixa" label="Novo"
                            icon="pi pi-plus" class="p-button-outlined sm:w-9rem"></button>
                    </div>
                </div>
            </div>
            <div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            </div>
            <p-table #dt1 [value]="listaCaixas" dataKey="id" [rows]="itensPaginados ? itensPaginados.size : 0"
                [loading]="loading" [rowHover]="true" [paginator]="true" (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0" [lazy]="true"
                [showCurrentPageReport]="true" responsiveLayout="stack" styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="p-fluid w-full sm:w-auto sm:mr-2">
                            <p-dropdown [options]="listaStatus" emptyFilterMessage="Nenhum registro" name="situacao"
                                ngModel #situacao="ngModel" [(ngModel)]="statusSelecionado"
                                emptyMessage="Nenhum registro" (onChange)="listarCaixas()">
                            </p-dropdown>
                        </div>
                        <div class="p-fluid w-full sm:w-auto mt-2 sm:mt-0">
                            <div class="flex">
                                <p-calendar class="w-full sm:w-auto" [readonlyInput]="false" [showIcon]="true"
                                    dateFormat="dd/mm/yy" [showButtonBar]="false" ngModel [(ngModel)]="dataCaixa"
                                    appendTo="body" (ngModelChange)="buscar()" placeholder="Busca por data">
                                </p-calendar>
                                <span class="ml-2">
                                    <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dataCaixa">
                            Data
                            <p-sortIcon field="dataCaixa">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="status">
                            Situação
                            <p-sortIcon field="status">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="quantidadeComandas">
                            Qtd. Comandas
                            <p-sortIcon field="dataCquantidadeComandasaixa">
                            </p-sortIcon>
                        </th>
                        <th style="text-align: center;">
                            <div>
                                Ações
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{item.dataCaixa | date:'dd/MM/yyyy'}}
                        </td>
                        <td>
                            <span class="product-badge bg-blue-600 admihair-text-white"
                                *ngIf="item.status === 'ABERTO'">ABERTO</span>
                            <span class="product-badge bg-cyan-600 admihair-text-white"
                                *ngIf="item.status === 'REABERTO'">REABERTO</span>
                            <span class="product-badge bg-green-600 admihair-text-white"
                                *ngIf="item.status === 'FECHADO'">FECHADO</span>
                        </td>
                        <td>
                            {{item.quantidadeComandas}}
                        </td>
                        <td style="text-align: center;">
                            <button pButton pRipple pTooltip="Detalhar" *ngIf="permissaoDetalhar"
                                (click)="redirecionarPagina('/apps/caixa-gerenciar/detalhar/' + item.id)"
                                icon="pi pi-eye" class="p-button-info mr-2 mb-2"></button>
                            <button pButton pRipple pTooltip="Editar" *ngIf="permissaoEditar"
                                (click)="redirecionarPagina('/apps/caixa-gerenciar/editar/' + item.id)"
                                icon="pi pi-pencil" class="p-button-success mr-2 mb-2"></button>
                        </td>

                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-dialog header="Abrir Caixa" [(visible)]="exibirDialogAbrirCaixa" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="true">
    <div class="card">
        <div class="formgroup">
            <div class="p-fluid p-formgrid grid justify-content-between">
                <div class="field col-12 md:col-12">
                    <label for="">Data Caixa</label>
                    <p-calendar [readonlyInput]="false" [showIcon]="true" dateFormat="dd/mm/yy" [showButtonBar]="false"
                        ngModel [(ngModel)]="dataSelecionadaNovoCaixa" [maxDate]="dataAtual" appendTo="body"
                        placeholder="Selecione">
                    </p-calendar>
                </div>
            </div>
        </div>

    </div>
    <p-footer>
        <div class="flex justify-content-between">
            <button type="button" pButton [icon]="loadingSpinnerAbrirCaixa ? 'pi pi-spin pi-spinner':'pi pi-check'"
                label="Confirmar" class="p-button-success mt-2" (click)="abrirCaixa()"
                [disabled]="loadingSpinnerAbrirCaixa"></button>
            <button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
                (click)="exibirDialogAbrirCaixa = false" [disabled]="loadingSpinnerAbrirCaixa"></button>
        </div>
    </p-footer>
</p-dialog>